import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import FormProfileImageHandler from '../Components/ReactHookFormCustom/FormProfileImageHandler';
import FormInput from '../Components/ReactHookFormCustom/FormInput';
import FormLocationFull from '../Components/ReactHookFormCustom/FormLocationFull';
import FormDateTime from '../Components/ReactHookFormCustom/FormDateTime';
import FormDropzone from '../Components/ReactHookFormCustom/FormDropzone';
import { useTranslation } from 'react-i18next';
import { emailFormat, dateFormat, urlFormat } from '../Components/ReactHookFormCustom/FormHelpers';
import FormRadioButtons from '../Components/ReactHookFormCustom/FormRadioButtons';
import { getCountries } from '../Services/countries';

const InsertApplicantBody = ({ control, setValue, email, applicant }) => {
  const { t, i18n } = useTranslation();
  const countries = getCountries(i18n.language);

  useEffect(() => {
    if (email) {
      setValue('email', email);
    }

    if (applicant) {
      setValue('id', applicant.id);
      setValue('email', applicant.email);
      setValue('firstName', applicant.firstName);
      setValue('firstName', applicant.firstName);
      setValue('lastName', applicant.lastName);
      setValue('phoneNumber', applicant.phoneNumber);
      applicant.dateOfBirth &&
        applicant.dateOfBirth !== '0001-01-01T00:00:00' &&
        setValue('birthDate', new Date(applicant.dateOfBirth));
      applicant.gender && setValue('gender', applicant.gender);

      if (applicant.address) {
        let countryOption = countries.find(
          (c) => c?.value?.toLowerCase() === applicant.address?.countryCode?.toLowerCase()
        );

        setValue('countryControllerSelect', countryOption, { shouldValidate: true });
        setValue(
          'cityControllerSelect',
          applicant.address.city ? { label: applicant.address.city, value: applicant.address.city } : null,
          { shouldValidate: true }
        );
        setValue(
          'streetControllerSelect',
          applicant.address.street ? { label: applicant.address.street, value: applicant.address.street } : null,
          { shouldValidate: true }
        );
      }

      setValue('cvFile', applicant.cvUrl);
      setValue('linkedInUrl', applicant.linkedInUrl);
      setValue('xUrl', applicant.xUrl);
      setValue('facebookUrl', applicant.facebookUrl);
      setValue('instagramUrl', applicant.instagramUrl);
      setValue('personalWebsiteUrl', applicant.personalWebsiteUrl);
      setValue('profilePhoto', applicant.profilePicture);
    }
  }, [email, setValue, applicant]);

  return (
    <>
      <Row className="align-items-center justify-content-center pb-3">
        <Col xs="12" md="6" lg="3" style={{ maxWidth: '120px', minWidth: '30px' }}>
          <FormProfileImageHandler
            control={control}
            label={t('common.ADD_IMAGE')}
            name="profilePhoto"
            id="profilePhotoId"
            imgUrl={applicant?.profilePicture ? applicant?.profilePicture : null}
            setValue={setValue}
          />
        </Col>
      </Row>
      <Row className="pb-3">
        <Col lg={4}>
          <FormInput
            disabled={email && email}
            control={control}
            name="email"
            id="emailId"
            label={t('common.E_MAIL')}
            rules={{
              required: t('common.REQUIRED'),
              pattern: {
                value: emailFormat,
                message: t('settings.EMAIL_HELP'),
              },
            }}
          />
        </Col>
        <Col lg={4}>
          <FormInput
            control={control}
            name="firstName"
            id="firstNameId"
            label={t('common.FIRST_NAME')}
            rules={{ required: t('common.REQUIRED') }}
          />
        </Col>
        <Col lg={4}>
          <FormInput
            control={control}
            name="lastName"
            id="lastNameId"
            label={t('common.LAST_NAME')}
            rules={{
              required: t('common.REQUIRED'),
            }}
          />
        </Col>
      </Row>
      <Row className="pb-3">
        <Col lg={4}>
          <FormInput control={control} name="phoneNumber" id="phoneNumberId" label={t('common.PHONE_NUMBER')} />
        </Col>
        <Col lg={4}>
          <FormDateTime
            control={control}
            label={t('applicants.DATE_OF_BIRTH')}
            name="birthDate"
            id="birthDateId"
            timeFormat={false}
            rules={{
              pattern: {
                value: dateFormat,
                message: t('settings.DATE_FORMAT_HELP'),
              },
            }}
          />
        </Col>
        <Col>
          <FormRadioButtons
            control={control}
            name="gender"
            id="genderId"
            label={t('common.GENDER')}
            options={[
              { value: 'male', label: t('common.MALE') },
              { value: 'female', label: t('common.FEMALE') },
            ]}
          />
        </Col>
      </Row>
      <Row className="pb-4">
        <FormLocationFull control={control} setValue={setValue} address={applicant?.address} />
      </Row>
      <Row className="align-items-center justify-content-center pb-3">
        <Col xs="12" lg="6">
          <FormDropzone
            control={control}
            name="cvFile"
            id="cvFileId"
            text={t('common.INSERT_CV')}
            setValue={setValue}
          />
        </Col>
      </Row>
      <Row className="pb-3">
        <Col lg={6}>
          <FormInput
            control={control}
            name="linkedInUrl"
            id="linkedInUrlId"
            label={t('applicant.LINKEDIN_URL')}
            rules={{
              pattern: {
                value: urlFormat,
                message: t('common.INVALID_URL'),
              },
            }}
          />
        </Col>
        <Col lg={6}>
          <FormInput
            control={control}
            name="personalWebsiteUrl"
            id="personalWebsiteUrlId"
            label={t('applicant.PERSONAL_URL')}
            // placeholder={t('applicant.PERSONAL_URL_PLACEHOLDER')}
            rules={{
              pattern: {
                value: urlFormat,
                message: t('common.INVALID_URL'),
              },
            }}
          />
        </Col>
      </Row>
      <Row className="pb-3">
        <Col lg={6}>
          <FormInput
            control={control}
            name="facebookUrl"
            id="facebookUrlId"
            label={t('applicant.FACEBOOK_URL')}
            rules={{
              pattern: {
                value: urlFormat,
                message: t('common.INVALID_URL'),
              },
            }}
          />
        </Col>
        <Col lg={6}>
          <FormInput
            control={control}
            name="xUrl"
            id="xUrlId"
            label={t('applicant.X_URL')}
            rules={{
              pattern: {
                value: urlFormat,
                message: t('common.INVALID_URL'),
              },
            }}
          />
        </Col>
      </Row>
      <Row className="pb-3">
        <Col lg={6}>
          <FormInput
            control={control}
            name="instagramUrl"
            id="instagramUrlId"
            label={t('applicant.INSTAGRAM_URL')}
            rules={{
              pattern: {
                value: urlFormat,
                message: t('common.INVALID_URL'),
              },
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default InsertApplicantBody;
